import { IContentList } from './i-content-list';

export interface IContentListResponse {
  results: IContentList[];
  totalCount: number;
}
export class ContentListResponse implements IContentListResponse {
  constructor(
    public results: IContentList[] = [],
    public totalCount: number = 0,
  ) {}
}
